import React from 'react';
import ModalLayout from './ModalLayout';
import { BOT_NAME } from '../../constants/constants';
import { toast } from 'react-toastify';
import QRCode from 'react-qr-code';
import { FiCopy, FiExternalLink, FiLogIn } from 'react-icons/fi';

function LoginModal({ closeModal, token }) {
  const handleCopyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('Скопировано в буфер обмена!');
      })
      .catch((err) => {
        console.error('Failed to copy text:', err);
      });
  };

  const botLink = `tg://resolve?domain=${BOT_NAME}&start=${token}`; // `https://t.me/${BOT_NAME}?start=${token}`;

  return (
    <ModalLayout closeModal={closeModal} className="!max-w-fit">
      <div className="p-1 space-y-4">
        <h1 className="text-center text-gray-800 font-bold text-lg lg:text-2xl  px-2">
          Авторизация через Telegram
        </h1>

        <div className="flex-col space-y-2 rounded-lg p-3 border border-gray-300">
          <p className="text-slate-700 mb-3">
            Отправьте эту команду нашему{' '}
            <a
              href={`https://t.me/${BOT_NAME}?start=${token}`}
              target="_blank"
              rel="noreferrer"
              className="text-purple-700 underline hover:text-blue-700"
            >
              телеграм-боту
            </a>
            :
          </p>

          <div className="flex items-center overflow-y-hidden">
            <div
              onClick={() => handleCopyToClipboard(`/start ${token}`)}
              className="flex-1 p-3 rounded-md bg-white border border-gray-200 hover:border-sky-300 cursor-pointer group transition-colors"
            >
              <div className="flex justify-between items-center">
                <div className="overflow-x-auto whitespace-nowrap scrollbar-hide">
                  <span className="text-sky-600 font-mono">/start</span>{' '}
                  <span className="text-gray-600 font-mono">{token}</span>
                </div>
                <FiCopy className="text-sky-400 group-hover:text-sky-600 ml-2 flex-shrink-0" />
              </div>
            </div>
          </div>

          <div className="flex justify-start">
            <span className="text-xs opacity-80 text-gray-600 flex items-center">
              ↑ Нажмите для копирования
            </span>
          </div>
        </div>

        <div className="flex flex-col justify-between sm:flex-row  rounded-lg p-3 border border-gray-300">
          <div className="flex flex-col space-y-4">
            <p className="text-slate-600">Или откройте бота по ссылке:</p>
            <a
              href={botLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center p-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-emerald-100 border border-gray-200 transition-colors"
            >
              <span>Открыть @{BOT_NAME}</span>
              <FiExternalLink className="ml-2" />
            </a>
          </div>

          <div className="flex flex-col items-center pt-2">
            <div className="p-3 bg-white rounded-lg border border-gray-300 mb-2">
              <QRCode
                size={180}
                style={{ height: 'auto', width: '100%' }}
                value={botLink}
                viewBox={`0 0 180 180`}
                fgColor="#000"
                bgColor="transparent"
              />
            </div>
            <p className="text-xs text-gray-500 text-center max-w-[200px]">
              Или отсканируйте QR-код
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 border text-sm text-slate-500">
          <p className="font-medium text-lg text-sky-800 mb-2">
            Это безопасно:
          </p>
          <ul className="list-disc list-inside">
            <li className="text-gray-800">
              Простая отправка сообщения с кодом авторизации нашему боту
            </li>
            <li className="text-gray-800">
              Мы не получаем доступ к вашему аккаунту Telegram
            </li>
          </ul>
        </div>
        <div className="max-w-[600px] bg-stone-50 rounded-xl p-3 border text-sm text-slate-500">
          Продолжая вход и использование сайта, вы соглашаетесь с{' '}
          <a
            className="text-blue-600"
            href="https://iopp.io/legal/privacy.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Политикой конфиденциальности
          </a>{' '}
          и{' '}
          <a
            className="text-blue-600"
            href="https://iopp.io/legal/agreement.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Пользовательским соглашением
          </a>
          .
        </div>
      </div>
    </ModalLayout>
  );
}

export default LoginModal;
